import React, { useState } from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import MenuIcon from '@material-ui/icons/Menu';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import StarBorder from '@material-ui/icons/StarBorder';
import VerifiedUser from '@material-ui/icons/VerifiedUser';
import Collapse from '@material-ui/core/Collapse';
import Icon from '@material-ui/core/Icon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import library from './Icons';
import SearchInput from './Search';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { withRouter } from "react-router";


const styles = theme => ({
    root: {
        width: '360px',
        maxWidth: "360px",
        backgroundColor: theme.palette.background.paper,
    },
    hideOverflownText: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    },
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    nestedSub: {
        paddingLeft: theme.spacing(8),
    },
    selectable: {
        cursor: "pointer"
    },
    selected: {
        backgroundColor: "#007bff",
        color: "white"
    }
});

const MenuLayout = (props) => {
    const { classes, toggleMenu, selectVideo, menu, children, setFilteredMenu } = props;
    return (
        <div
            className={`${classes.root} drawer`}
            role="presentation"
        >
            <List>
                <ListItem>
                    <ListItemIcon><MenuIcon className={classes.selectable} onClick={() => toggleMenu(false)} /></ListItemIcon>
                </ListItem>
                <ListItem className="drawer-search-item">
                    <SearchInput selectVideo={selectVideo} setFilteredMenu={props.setFilteredMenu} data={menu} />
                </ListItem>
            </List>
            <Divider />
            <List /*key={index}*/>
                {children}
            </List>
        </div>
    )
}

class TemporaryDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            change: false
        };
        this.generateMenuItems = this.generateMenuItems.bind(this);
    }

    componentDidMount() { }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.menu) !== JSON.stringify(this.props.menu)){
            this.setState({ change: !this.state.change })
        }
    }

    generateMenuItems = (menu, selectedVideo, classes, selectVideo, builtContent = null) => {
        if (menu) {
            if (Array.isArray(menu)) {
                let builtContent = <ListItem><ListItemText className="text-center" primary="No hay datos" /></ListItem>

                if (menu.length > 0){
                    builtContent = <>{menu.map(menuItem => this.generateMenuItems(menuItem, selectedVideo, classes, selectVideo))}</>
                }

                return builtContent
            } else {
                let menuItem = menu;
                if (typeof menuItem === "object") {
                    if (menuItem["children"] && menuItem["children"]?.length > 0) {
                        return (
                            <>
                                <div className={selectedVideo && (selectedVideo.id === menuItem.id) ? classes.selected : ""}>
                                    <ListItem button onClick={() => (menuItem.children && menuItem.children.length > 0) ? this.props.updateMenu(menuItem.id, !menuItem.expanded) : (menuItem.video) ? selectVideo(menuItem) : {}}>
                                        <ListItemIcon><FontAwesomeIcon className={selectedVideo && (selectedVideo.id === menuItem.id) ? classes.selected : ""} icon={menuItem.icon||"ellipsis-v"} /></ListItemIcon>
                                        <ListItemText /*className={classes.hideOverflownText}*/ primary={menuItem.label||menuItem.title} />
                                        {menuItem.children && menuItem.children.length > 0 ? (menuItem.expanded ? <ExpandLess /> : <ExpandMore />) : ""}
                                    </ListItem>
                                    <Collapse in={menuItem.expanded} timeout="auto" unmountOnExit>
                                        <List component="div" /*disablePadding*/>
                                            <>{menuItem.children.map(child => this.generateMenuItems(child, selectedVideo, classes, selectVideo))}</>
                                        </List>
                                    </Collapse>
                                </div>
                                <Divider />
                            </>
                        )
                    } else {
                        return (
                            <>
                                <div className={selectedVideo && (selectedVideo.id === menuItem.id) ? classes.selected : ""}>
                                    <ListItem button onClick={() => (menuItem.children && menuItem.children.length > 0) ? this.props.updateMenu(menuItem.id, !menuItem.expanded) : (menuItem.video) ? selectVideo(menuItem) : {}}>
                                        <ListItemIcon><FontAwesomeIcon className={selectedVideo && (selectedVideo.id === menuItem.id) ? classes.selected : ""} icon={menuItem.icon||"ellipsis-v"} /></ListItemIcon>
                                        <ListItemText /*className={classes.hideOverflownText}*/ primary={menuItem.label||menuItem.title} />
                                    </ListItem>
                                </div>
                                <Divider />
                            </>
                        )
                    }
                }
            }
        }
    }

    render() {
        const { toggleDrawer, open, classes, selectVideo, selectedVideo, toggleMenu } = this.props;
        const { menu, filteredMenu } = this.props;
        const list = (item) => (
            <div
                className={classes.root}
                role="presentation"
            >
                <List>
                    <ListItem>
                        <ListItemIcon><MenuIcon className={classes.selectable} onClick={() => toggleMenu(false)} /></ListItemIcon>
                    </ListItem>
                    <ListItem style={{ backgroundColor: "lightgray" }}>
                        <SearchInput selectVideo={selectVideo} setFilteredMenu={this.props.setFilteredMenu} data={menu} />
                    </ListItem>
                </List>
                <Divider />
                {
                    item.map((level1, index) => {
                        return (
                            <>
                                <List key={index}>
                                    <div className={selectedVideo && (selectedVideo.id === level1.id) ? classes.selected : ""}>
                                        <ListItem button onClick={() => (level1.children && level1.children.length > 0) ? this.props.updateMenu(level1.id, !level1.expanded) : (level1.video) ? selectVideo(level1) : {}}>
                                            <ListItemIcon><FontAwesomeIcon className={selectedVideo && (selectedVideo.id === level1.id) ? classes.selected : ""} icon={level1.icon} /></ListItemIcon>
                                            <ListItemText className={classes.hideOverflownText} primary={level1.label} />
                                            {level1.children && level1.children.length > 0 ? (level1.expanded ? <ExpandLess /> : <ExpandMore />) : ""}
                                        </ListItem>
                                    </div>
                                    <Collapse in={level1.expanded} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            {
                                                level1.children && level1.children.length > 0 ? level1.children.map((level2, subIndex) => {
                                                    return (
                                                        <>
                                                            <div className={selectedVideo && (selectedVideo.id === level2.id) ? classes.selected : ""}>
                                                                <ListItem button onClick={() => (level2.children && level2.children.length > 0) ? this.props.updateMenu(level2.id, !level2.expanded) : (level2.video) ? selectVideo(level2) : {}} className={classes.nested} key={subIndex}>
                                                                    <ListItemIcon><FontAwesomeIcon className={selectedVideo && (selectedVideo.id === level2.id) ? classes.selected : ""} icon={level2.icon} /></ListItemIcon>
                                                                    <ListItemText className={classes.hideOverflownText} primary={level2.label} />
                                                                    {level2.children && level2.children.length > 0 ? (level2.expanded ? <ExpandLess /> : <ExpandMore />) : ""}
                                                                </ListItem>
                                                            </div>
                                                            <Collapse in={level2.expanded} timeout="auto" unmountOnExit>
                                                                <List component="div" disablePadding>
                                                                    {
                                                                        level2.children && level2.children.length > 0 ? level2.children.map((level3, subIndex) => {
                                                                            return (
                                                                                <div className={selectedVideo && (selectedVideo.id === level3.id) ? classes.selected : ""}>
                                                                                    <ListItem onClick={() => level3.video ? selectVideo(level3) : {}} button className={classes.nestedSub} key={subIndex}>
                                                                                        <ListItemIcon><FontAwesomeIcon className={selectedVideo && (selectedVideo.id === level3.id) ? classes.selected : ""} icon={level3.icon} /></ListItemIcon>
                                                                                        <ListItemText className={classes.hideOverflownText} primary={level3.label} />
                                                                                    </ListItem>
                                                                                </div>
                                                                            )
                                                                        }) : ""
                                                                    }
                                                                </List>
                                                            </Collapse>
                                                        </>
                                                    )
                                                }) : ""
                                            }
                                        </List>
                                    </Collapse>
                                </List>
                                <Divider />
                            </>
                        )
                    })
                }
            </div >
        );

        const filteredList = (item) => (
            <div
                className={classes.root}
                role="presentation"
            >
                <List>
                    <ListItem>
                        <ListItemIcon><MenuIcon className={classes.selectable} onClick={() => toggleMenu(false)} /></ListItemIcon>
                    </ListItem>
                    <ListItem style={{ backgroundColor: "lightgray" }}>
                        <SearchInput selectVideo={selectVideo} setFilteredMenu={this.props.setFilteredMenu} data={menu} />
                    </ListItem>
                </List>
                <Divider />
                <List>
                    {
                        item.map((x, index) => {
                            return (
                                <div className={selectedVideo && (selectedVideo.id === x.id) ? classes.selected : ""}>
                                    <ListItem onClick={() => x.video ? selectVideo(x) : {}} button>
                                        <ListItemIcon><FontAwesomeIcon icon={x.icon} /></ListItemIcon>
                                        <ListItemText className={classes.hideOverflownText} primary={x.label} />
                                    </ListItem>
                                </div>
                            )
                        })
                    }
                </List>
            </div>
        );

        return (
            <div>
                <React.Fragment>
                    <Drawer anchor={"left"} open={open} onClose={() => toggleMenu(false)}>
                        <MenuLayout classes={classes} toggleMenu={toggleMenu} selectVideo={selectVideo} menu={menu} setFilteredMenu={this.props.setFilteredMenu}>
                            {this.generateMenuItems((filteredMenu && filteredMenu.length > 0 ? filteredMenu : menu), selectedVideo, classes, selectVideo)}
                        </MenuLayout>
                    </Drawer>
                </React.Fragment>
            </div>
        );
    }
}

export default withRouter((withStyles(styles)(TemporaryDrawer)));